import {
    AxiosHeaders,
    IRequestFetcherOptions
} from "src/common/razzle-platform-components/types"
import axios from 'src/common/razzle-platform-components/axios'
import {BASE_API_URL, CATEGORY_OF_PRODUCT_API_END_POINT} from 'src/common/razzle-platform-categoryofproduct/configs'


export const fetchCategoryOfProduct = async (id: string, options: Pick<IRequestFetcherOptions, 'params'>, headers: AxiosHeaders={}) => {

    const params = options.params || {}

    const response = await axios.get(`${BASE_API_URL}${CATEGORY_OF_PRODUCT_API_END_POINT}/${id}`, {params, headers})

    return { categoryOfProduct: response.data }
}


export const fetchCategoriesOfProduct = async (options: IRequestFetcherOptions={params: null, useUrlParams: true, usePagination: true, searchParams: null }, headers: AxiosHeaders={}) => {

    let params = {
        _page: '1',
        _per_page: '8',
    }

    if (options.useUrlParams) {
        params = { ...params, ...options.searchParams }
    }

    if (options.params) {
        params = {...params, ...options.params}
    }

    if (options.usePagination === false) {
        delete params._page
        delete params._per_page
    }

    const response = await axios.get(`${BASE_API_URL}${CATEGORY_OF_PRODUCT_API_END_POINT}`, {params, headers})

    const count = parseInt(response.headers['x-total-count'], 10)

    const pagination = {
        count,
        page: parseInt(params._page || '1', 10),
        perPage: options.usePagination ? parseInt(params._per_page, 10) : count,
    }
    return { categoriesOfProduct: response.data, pagination}
} 